<template>
  <div id="content">
    <div id="news">
      <div class="news">
        <ul>
          <li v-for="cl in news"
              :key="cl.id">
            <a :href="'/#/newsdetail/' + cl.id">
              <img :src="cl.image"
                   alt="" /></a>
            <span class="news01 le">
              <span><a v-if="$i18n.locale=='en'"
                   :href="'/#/newsdetail/' + cl.id">{{cl.name_en}} </a>
                <a v-else
                   :href="'/#/newsdetail/' + cl.id"> {{cl.name}} </a>
              </span>
              <p><a :href="'/#/newsdetail/' + cl.id"></a></p>

              <a v-if="$i18n.locale=='en'"
                 :href="'/#/newsdetail/' + cl.id"
                 class="news_more">MORE &gt;&gt;</a>
              <a v-else
                 :href="'/#/newsdetail/' + cl.id"
                 class="news_more">查看详情 &gt;&gt;</a>
            </span>
            <span class="news02 fr">
              <span>{{cl.day}}</span>
              <p>{{cl.year}}-{{cl.month}}</p>
            </span>
            <div class="clear"></div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import fetch from "@/utils/axios";
export default {
  data () {
    return {
      news: []
    };
  },
  mounted () {
    // 使用
    const params = {}; // 参数
    fetch.post("/api/ApiNews/GetAllNewsList", params).then(
      (res) => {
        this.news = res;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
  }
};
</script>

<style>
#news {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

/*4-1新闻动态*/
.news {
  width: 1190px;
  margin: 5px auto auto;
}
.news li {
  width: 95%;
  padding: 20px 20px;
  height: 140px;
  border: 1px #f5f5f5 solid;
  margin-top: 20px;
}
.news li img {
  display: block;
  float: left;
  width: 210px;
  height: 140px;
  overflow: hidden;
  border: 0;
}
.news01 {
  display: block;
  margin-left: 40px;
  width: 690px;
}
.news01 span {
  display: block;
  width: 100%;
  height: 30px;
  line-height: 30px;
  overflow: hidden;
  font-size: 14px;
}
.news01 span a {
  color: #333;
  font-size: 18px;
  font-weight: bolder;
}
.news01 p {
  width: 100%;
  font-size: 14px;
  line-height: 28px;
  height: 56px;
  overflow: hidden;
  margin-top: 10px;
}
.news01 p a {
  display: block;
  color: #666;
}
.news_more {
  display: block;
  font-size: 14px;
  color: #666;
  margin-top: 20px;
}

.news li:hover {
  background: #fafafa;
}
.news li:hover .news01 .news_more {
  color: #01a4e9;
}
.news02 {
  width: 66px;
  height: 92px;
  border-left: 1px #f5f5f5 solid;
  color: #666;
  padding-left: 40px;
  padding-top: 28px;
  margin-top: 10px;
}
.news02 span {
  display: block;
  font-size: 38px;
  line-height: 40px;
}
.news02 p {
  font-size: 12px;
}
.news li:hover .news02 {
  border-left: 1px #f0f0f0 solid;
}
</style>



// WEBPACK FOOTER //
// src/News.vue